var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 15,
    viewBox: "0 0 20 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0694 5.86591C9.16395 5.86554 5.30598 5.86659 1.44802 5.86344C0.752908 5.86287 0.474291 5.56538 0.510997 4.89674C0.535609 4.44842 0.763916 4.20441 1.15629 4.14051C1.3112 4.11529 1.47191 4.13061 1.62997 4.1306C6.35756 4.13051 11.0852 4.13081 15.8127 4.13105C15.9845 4.13106 16.1563 4.13105 16.3608 4.13105C16.3384 3.87639 16.1766 3.77513 16.0642 3.64989C15.4445 2.95928 14.8076 2.28676 14.1967 1.58712C13.7125 1.03251 13.8312 0.319803 14.4212 0.0646639C14.7615 -0.0824896 15.0523 0.0336694 15.289 0.29018C16.6471 1.76191 17.9951 3.24478 19.3517 4.71806C19.5378 4.92014 19.5415 5.07333 19.3527 5.27815C18.0064 6.73835 16.6716 8.21119 15.3222 9.66798C14.9255 10.0962 14.4881 10.1012 14.1433 9.73491C13.7991 9.36928 13.8047 8.84446 14.1938 8.40182C14.7632 7.75422 15.3535 7.12869 15.933 6.49177C16.0637 6.34814 16.1869 6.19632 16.3135 6.04826C16.3043 5.98748 16.2951 5.92669 16.2859 5.8659C15.2295 5.8659 14.1732 5.8659 13.0694 5.86591Z",
    fill: "url(#paint0_linear_1595_89984)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1595_89984",
    x1: -3.48903,
    y1: 5.78947,
    x2: 21.8894,
    y2: 7.67892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89D9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B72F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.67d44ba0fbd13c1b539f8344c7fd635d.svg";
export { ForwardRef as ReactComponent };